/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Value_LabelInputs */

const en_options_metadata_value_label = /** @type {(inputs: Options_Metadata_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata Value`)
};

const fr_options_metadata_value_label = /** @type {(inputs: Options_Metadata_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur de métadonnée`)
};

const de_options_metadata_value_label = /** @type {(inputs: Options_Metadata_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatenwert`)
};

const it_options_metadata_value_label = /** @type {(inputs: Options_Metadata_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore dei metadati`)
};

const ru_options_metadata_value_label = /** @type {(inputs: Options_Metadata_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значение метаданных`)
};

const es_options_metadata_value_label = /** @type {(inputs: Options_Metadata_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor de metadatos`)
};

const zh_cn2_options_metadata_value_label = /** @type {(inputs: Options_Metadata_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据值`)
};

const ja_options_metadata_value_label = /** @type {(inputs: Options_Metadata_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータ値`)
};

const hi_options_metadata_value_label = /** @type {(inputs: Options_Metadata_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा मान`)
};

const pt_pt2_options_metadata_value_label = /** @type {(inputs: Options_Metadata_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor dos metadados`)
};

/**
* | output |
* | --- |
* | "Metadata Value" |
*
* @param {Options_Metadata_Value_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_value_label = /** @type {((inputs?: Options_Metadata_Value_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Value_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metadata_value_label(inputs)
	if (locale === "de") return de_options_metadata_value_label(inputs)
	if (locale === "it") return it_options_metadata_value_label(inputs)
	if (locale === "ru") return ru_options_metadata_value_label(inputs)
	if (locale === "es") return es_options_metadata_value_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metadata_value_label(inputs)
	if (locale === "ja") return ja_options_metadata_value_label(inputs)
	if (locale === "hi") return hi_options_metadata_value_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metadata_value_label(inputs)
	return en_options_metadata_value_label(inputs)
});